



















import mixins from 'vue-typed-mixins';
import ResourceVue from './Resource.vue';
import { ResourceLayout, ResourceCategory } from '@/utils/ResourceUtils';

export default mixins().extend({
  name: 'category',
  components: {
    resource: ResourceVue,
  },

  props: {
    value: {
      type: Object as () => ResourceCategory,
      required: true,
    },
  },

  data(): {
    collapsed: boolean;
  } {
    return {
      collapsed:
        this.value.options.collapsed !== undefined
          ? this.value.options.collapsed
          : true,
    };
  },

  computed: {
    /**
     * Returns the list of children to display based on the active locale
     */
    childrenByLocale: function() {
      const self = this;
      return this.value.children.filter(
          c => !(
              'language' in c
              && c.language !== 'any'
              && c.language !== self.$i18n.locale
          )
      );
    }
  },
});
